import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

export default class extends Controller {
  connect() {
    this.consumer = createConsumer()
    this.subscription = this.consumer.subscriptions.create("NotificationsChannel", {
      connected: () => {
        console.log("NotificationsChannel connected")
      },
      disconnected: () => {
        console.log("NotificationsChannel disconnected")
      },
      rejected: () => {
        console.log("NotificationsChannel rejected")
      },
      received: (data) => this.handleNotification(data)
    })
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
    if (this.consumer) {
      this.consumer.disconnect()
    }
  }

  handleNotification(data) {
    if (data.type === "board_generation_complete") {
      this.showBoardGenerationNotification(data)
    }
  }

  showBoardGenerationNotification(data) {
    const message = data.success
      ? `Board generated! ${data.cards_updated} cards updated for "${data.project_title}".`
      : `Board generation failed: ${data.error}`

    this.showToast(message, data.success ? "success" : "error")

    if (this.isOnBoardPage(data.project_id)) {
      // Reload the page to show the updated board
      setTimeout(() => window.location.reload(), data.success ? 1000 : 2000)
    }
  }

  isOnBoardPage(projectId) {
    return window.location.pathname.includes(`/projects/${projectId}/cards`)
  }

  showToast(message, type = "info") {
    const toast = document.createElement("div")
    const bgColor = type === "success" ? "bg-lime-500" : "bg-red-500"

    toast.className = `fixed bottom-4 right-4 ${bgColor} text-white px-6 py-3 rounded-lg shadow-lg z-50 transition-opacity duration-300`
    toast.textContent = message

    document.body.appendChild(toast)

    setTimeout(() => {
      toast.classList.add("opacity-0")
      setTimeout(() => toast.remove(), 300)
    }, 4000)
  }
}
